import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';
import SiteNavAMobileLevelCItem from 'components/SiteNav/SiteNavA/SiteNavAMobile/SiteNavAMobileLevelCItem';
import classes from './SiteNavAMobileLevelC.module.scss';

const SiteNavAMobileLevelC = (props) => {
  const {
    heading,
    subHeading,
    href,
    levelCVisible,
    items = [],
    onLevelCHeadingClick,
    onLevelCItemClick,
    activeLevelCItem,
  } = props;

  const arrowClassName = levelCVisible ? classes.arrowButtonOpen : classes.arrowButtonClosed;

  const arrowIcon = (
    <div className={arrowClassName}>
      <FontIcon title={`Show ${heading} Items`} icon='far fa-angle-down' />
    </div>
  );

  const menu = (
    <div className={classes.menuContainer}>
      {items.map((item, index) => {
        const id = `level-c-item-${index}`;
        return (
          <SiteNavAMobileLevelCItem
            heading={item.heading}
            subHeading={item.subHeading}
            href={item.href}
            onLevelCItemClick={onLevelCItemClick}
            id={id}
            isExpanded={id === activeLevelCItem}
            key={index}
            items={item.items}
          />
        );
      })}
    </div>
  );

  return (
    <div className={classes.container}>
      <button
        className={classes.heading}
        onClick={onLevelCHeadingClick}
        aria-label={heading}
        type='button'
      >
        <div className={classes.wrapper}>
          <div href={href} className={classes.title}>
            <div
              className={classes.headingText}
              dangerouslySetInnerHTML={{ __html: heading }}
            />
            <div
              className={classes.subheadingText}
              dangerouslySetInnerHTML={{ __html: subHeading }}
            />
          </div>
          <div className={classes.arrowWrapper}>
            {items.length ? arrowIcon : <div />}
          </div>
        </div>
      </button>
      {levelCVisible ? menu : null}
    </div>
  );
};

SiteNavAMobileLevelC.propTypes = {
  items: PropTypes.array,
  heading: PropTypes.string.isRequired,
  href: PropTypes.string,
  subHeading: PropTypes.string,
  levelCVisible: PropTypes.bool.isRequired,
  onLevelCHeadingClick: PropTypes.func.isRequired,
  onLevelCItemClick: PropTypes.func.isRequired,
  activeLevelCItem: PropTypes.string,
};

export default SiteNavAMobileLevelC;
